export enum EDangerZoneStatus {
    YELLOW = 'YELLOW',
    ORANGE = 'ORANGE',
    RED = 'RED',
}

export interface IDangerZoneGeoLongLat {
    type: 'Polygon';
    coordinates: number[][][];
}

export interface IDangerZone {
    _id: string;
    status: EDangerZoneStatus;
    geoLongLat: IDangerZoneGeoLongLat;
    country: string;
    notes?: string;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface IDangerZoneCreatePayload {
    status: EDangerZoneStatus;
    coordinates: number[][];
    country: string;
    notes?: string;
}

export interface IDangerZoneUpdatePayload {
    status?: EDangerZoneStatus;
    coordinates?: number[][];
    country?: string;
    notes?: string;
}
